/**
 * this function is responsible for organizing the backend fundamental data into the data acceptable by recharts.
 * @param {Object} data
 * @returns {Object}
 */
export default function getFundamentalistChartsData(data) {
  if (!data) {
    return null;
  }
  const requestResult = data.requestsResults.Fundamental;
  if (requestResult !== 7) {
    return null;
  }
  const fundamentalData = data.analysisResults.Fundamental;

  const {
    CashFlow: cashFlowData,
    PatrimonyBalance: PatrimonyBalanceData,
    ResultsDemonstration: ResultsDemonstrationData,
  } = fundamentalData;

  const messyData = {
    cashFlow: getCashFlowChartsData(cashFlowData),
    patrimonyBalance: getPatrimonyBalanceChartsData(PatrimonyBalanceData),
    resultsDemonstrations: getDemonstrationsChartsData(
      ResultsDemonstrationData
    ),
  };

  return organizeChartsData(messyData);
}

function getCashFlowChartsData(cashFlowData) {
  if (!cashFlowData) {
    return null;
  }
  const {
    FinancingActivity: financingActivityData,
    InvestimentsActivity: investimentsActivityData,
    LiquidVariations: liquidVariationsData,
    OperationalActivity: operationalActivityData,
  } = cashFlowData;

  const response = {
    financingActivity: organizeObject(financingActivityData),
    investimentsActivity: organizeObject(investimentsActivityData),
    liquidVariations: organizeObject(liquidVariationsData),
    operationalActivity: organizeObject(operationalActivityData),
  };
  return response;
}

function getPatrimonyBalanceChartsData(patrimonyBalanceData) {
  if (!patrimonyBalanceData) {
    return null;
  }
  const {
    TotalActive: activeData,
    TotalPassive: passiveData,
    TotalLiquid: liquidData,
  } = patrimonyBalanceData;

  const response = {
    totalActive: organizeObject(activeData),
    totalPassive: organizeObject(passiveData),
    totalLiquid: organizeObject(liquidData),
  };

  return response;
}

function getDemonstrationsChartsData(demonstrationData) {
  if (!demonstrationData) {
    return null;
  }

  const {
    ClearProfit: clearProfitData,
    GrossProfit: grossProfitData,
    OperationalReceipt: operationalReceiptData,
    TotalReceipt: totalReceiptData,
  } = demonstrationData;

  const response = {
    clearProfit: organizeObject(clearProfitData),
    grossProfit: organizeObject(grossProfitData),
    operationalReceipt: organizeObject(operationalReceiptData),
    totalReceipt: organizeObject(totalReceiptData),
  };

  return response;
}

function organizeObject(data) {
  if (!data) {
    return null;
  }
  var response = [];
  Object.keys(data).forEach((date) => {
    response.push({
      date: date,
      value: data[date],
    });
  });

  return response.reverse();
}

function organizeChartsData(data) {
  if (!data) {
    return null;
  }
  const cashFlowData = data.cashFlow;
  const patrimonyBalanceData = data.patrimonyBalance;
  const demonstrationsData = data.resultsDemonstrations;

  var cashFlowDataChart = [];
  var patrimonyBalanceChart = [];
  var resultsDemonstrationsChart = [];

  if (cashFlowData) {
    for (
      let i = 0;
      i < Object.keys(cashFlowData.operationalActivity).length;
      i++
    ) {
      cashFlowDataChart.push({
        name: cashFlowData.operationalActivity[i].date,
        financingActivity: cashFlowData.financingActivity[i].value,
        investimentsActivity: cashFlowData.investimentsActivity[i].value,
        liquidVariations: cashFlowData.liquidVariations[i].value,
        operationalActivity: cashFlowData.operationalActivity[i].value,
      });
    }
  }

  if (patrimonyBalanceData) {
    for (
      let i = 0;
      i < Object.keys(patrimonyBalanceData.totalLiquid).length;
      i++
    ) {
      patrimonyBalanceChart.push({
        name: patrimonyBalanceData.totalLiquid[i].date,
        totalPassive: patrimonyBalanceData.totalPassive[i].value,
        totalActive: patrimonyBalanceData.totalActive[i].value,
        totalLiquid: patrimonyBalanceData.totalLiquid[i].value,
      });
    }
  }

  if (demonstrationsData) {
    for (
      let i = 0;
      i < Object.keys(demonstrationsData.totalReceipt).length;
      i++
    ) {
      resultsDemonstrationsChart.push({
        name: demonstrationsData.totalReceipt[i].date,
        clearProfit: demonstrationsData.clearProfit[i].value,
        grossProfit: demonstrationsData.grossProfit[i].value,
        operationalReceipt: demonstrationsData.operationalReceipt[i].value,
        totalReceipt: demonstrationsData.totalReceipt[i].value,
      });
    }
  }

  return {
    cashFlow: cashFlowDataChart.length > 0 && cashFlowDataChart,
    patrimonyBalance: patrimonyBalanceChart.length > 0 && patrimonyBalanceChart,
    resultsDemonstrations:
      resultsDemonstrationsChart.length > 0 && resultsDemonstrationsChart,
  };
}
